// extracted by mini-css-extract-plugin
export default {"modal__row":"modal-form_modal__row__P1itv","modal__sendRow":"modal-form_modal__sendRow__4bZaV","modal__buttons":"modal-form_modal__buttons__OIAzl"};